export default "/static/assets/2ea49ab09cfa17fb.png"